(() => {
    const button3D = document.getElementById('ext-btn-3d');
    const buttonClose = document.getElementById('ext-btn-close');
    const wrapper3D = document.getElementById('ext-wrapper-3d');
    const container3D = document.getElementById('ext-product-3d');
    const annotations = document.querySelectorAll('.ext-annotation');
    const infoBox = document.getElementById('ext-hotspot-info');
    const mediaQuery = window.matchMedia("(max-width: 650px)");
    mediaQuery.addEventListener("change", handleOrientationChange);
    let viewer3D;
    let spinner;
    let spinnerText;
    let line;
    let swiper3d;

    function isMobile() {
        if (window.matchMedia("(max-width: 650px)").matches) {
        //console.log("Screen is 650px or smaller");
        return true;
        }
        return false;
    }
    function handleOrientationChange(event) {
        if (event.matches) {
            //console.log("Screen is 650px or smaller");
            initializeSlider();
        } else {
            //console.log("Screen is desktop");
            
            if(swiper3d && typeof swiper3d.destroy === 'function') {
                infoBox.children[0].classList.remove('swiper-wrapper');
                swiper3d.destroy(true, true);
                swiper3d = null;
            }
            sectionSetup();
        }
    }
    function init() {
        viewer3D = document.getElementById('ext-viewer-3d');
        spinner = document.querySelector('.viewer-spinner');
        spinnerText = document.querySelector('.spinner-text');
        line = document.getElementById('hotspot-line');
        if(isMobile()) {
            initializeSlider();
        }
    }
    function initializeSlider() {
        infoBox.children[0].classList.add('swiper-wrapper');
        swiper3d = new Swiper('.ext-hotspot-info', {
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction', // <-- This activates the counter
            },
            navigation: {
                nextEl: '#ext-hotspot-info .swiper-button-next',
                prevEl: '#ext-hotspot-info .swiper-button-prev',
            },
            on: {
                slideChange: function () {
                    hideAnnotations();
                    let hotspotId = this.slides[this.activeIndex].dataset.hotspot;
                    document.getElementById(hotspotId).classList.add('active')
                    //const activeIndex = this.realIndex + 1;
                    //console.log(this.slides[this.activeIndex]);
                },
            }
        });
    }

    function clickToSlide(activeHotspot) {
        const slideIndex = parseInt(activeHotspot.dataset.slide, 10);
        swiper3d.slideTo(slideIndex-1);
    }
    function hideSpinner() {
        spinner?.remove();
    }
    
    function showClose() {
        button3D.style.display = "none";
        buttonClose.style.display = "block";
    }
    function hideLine() {
        line.style.display='none';
    }
    function hideAnnotations() {
        annotations.forEach(annotation => {
            annotation.classList.remove('visible');
        });
        document.querySelectorAll('.ext-hotspot-button').forEach(hotspot => {
            hotspot.classList.remove('active');
        });
        hideLine();
    }
    function getActiveCard() {
        return document.querySelector(".ext-annotation.visible");
    }
    function getActiveHotspot() {
        return document.querySelector(".ext-hotspot-button.active");
    }
    function getRectIntersection(x1, y1, rect, wrapperRect) {

        const left = rect.left - wrapperRect.left;
        const top = rect.top - wrapperRect.top;
        const right = left + rect.width;
        const bottom = top + rect.height;

        const centerX = left + rect.width / 2;
        const centerY = top + rect.height / 2;

        const dx = centerX - x1;
        const dy = centerY - y1;

        let t = Infinity;

        // left/right edges
        if (dx !== 0) {
            const tx1 = (left - x1) / dx;
            const tx2 = (right - x1) / dx;

            if (tx1 > 0) t = Math.min(t, tx1);
            if (tx2 > 0) t = Math.min(t, tx2);
        }
        // top/bottom edges
        if (dy !== 0) {
            const ty1 = (top - y1) / dy;
            const ty2 = (bottom - y1) / dy;

            if (ty1 > 0) t = Math.min(t, ty1);
            if (ty2 > 0) t = Math.min(t, ty2);
        }
        return {
            x: x1 + dx * t,
            y: y1 + dy * t
        };
    }
    function updateLine(activeHotspot, activeCard) {
        //console.log('i runnn');
        if(!activeCard || !activeHotspot) {
            hideLine();
            return;
        }
        const wrapper = document.querySelector('.viewer-wrapper');
        const wrapperRect = wrapper.getBoundingClientRect();

        const hotspotRect = activeHotspot.getBoundingClientRect();
        const annotationRect = activeCard.getBoundingClientRect();

        const x1 = hotspotRect.left - wrapperRect.left + hotspotRect.width / 2;
        const y1 = hotspotRect.top - wrapperRect.top + hotspotRect.height / 2;

        const end = getRectIntersection(
            x1,
            y1,
            annotationRect,
            wrapperRect
        );
        line.setAttribute('x1', x1);
        line.setAttribute('y1', y1);
        line.setAttribute('x2', end.x);
        line.setAttribute('y2', end.y);
        line.style.display='block';
    }
    function sectionSetup() {
        hideAnnotations();
        infoBox.style.display = "block";
    }
    
    function handleHotspotClick(event) {
        const activeCard = document.querySelector(`[data-hotspot="${event.target.id}"]`);
        const activeHotspot = document.getElementById(event.target.id);
        hideAnnotations();
        activeHotspot.classList.add('active');
        activeCard.classList.add('visible');
        updateLine(activeHotspot, activeCard);
        if(isMobile()) {
            clickToSlide(activeHotspot);
            /*activeCard.scrollIntoView({ 
            behavior: "smooth", 
            block: "end"
            });*/
        }
    }
    function handleMobileAccordionClick(event) {
        //console.log('handle');
        hideAnnotations();
        //console.log(event.target);
        const hotspotId = event.currentTarget.dataset.hotspot;
        //console.log(hotspotId);
        const activeHotspot = document.getElementById(hotspotId);
        event.currentTarget.classList.add('visible');
        activeHotspot.classList.add('active');
    }
    function hideViewer() {
        hideAnnotations();
        container3D.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0076/8983/0457/files/pico-placeholder.png" alt="Pico Car Seat in Jet" width="700" height="auto" class="ext-poster-3d ext-mx-auto" />`;
         //wrapper3D.style.height = "0";
        buttonClose.style.display = "none";
        button3D.style.display = "block";
    }

    function bindEvents() {
        viewer3D?.addEventListener('progress', (event) => {
            const percent = Math.round(event.detail.totalProgress * 100);
            spinnerText.textContent = `Loading ${percent}%`;
        });
        viewer3D?.addEventListener('load', hideSpinner);
        buttonClose?.addEventListener('click', hideViewer);
        document.querySelectorAll('.ext-hotspot-button').forEach(hotspot => {
            hotspot.addEventListener('click', handleHotspotClick); 
        });
        container3D.addEventListener('click', (event) => {
            const hotspot = event.target.closest('.ext-hotspot-button');
            if (!hotspot) {
                //console.log('Clicked empty model area');
                //hideAnnotations();
            }
        });
        viewer3D?.addEventListener('click', (event) => {
            const hit = viewer3D.positionAndNormalFromPoint(event.clientX, event.clientY);

            if (!hit) {
                //console.log('Clicked outside the model');
                hideAnnotations();
                return;
            }

            //console.log('Position:', hit.position.toString());
            //console.log('Normal:', hit.normal.toString());
        });
        viewer3D.addEventListener('camera-change', () => {
            updateLine(getActiveHotspot(), getActiveCard());
        });
        viewer3D.addEventListener('load', sectionSetup);
        window.addEventListener('resize', hideAnnotations);
        annotations.forEach(annotation => {
            annotation.addEventListener('click', handleMobileAccordionClick); 
        });
    }

    async function load3D() {

        if (!customElements.get('model-viewer')) {
            await import('https://ajax.googleapis.com/ajax/libs/model-viewer/4.1.0/model-viewer.min.js');
        }
        wrapper3D.style.height = "auto";
        wrapper3D.style.opacity = "1";


        container3D.innerHTML = `
         <div class="viewer-wrapper ext-relative">

        <div class="viewer-spinner">
            <div class="spinner"></div>
            <div class="spinner-text">Loading 0%</div>
        </div>
            <model-viewer
            id="ext-viewer-3d" src="https://cdn.shopify.com/3d/models/922f436d9c21fbbc/WAYB_GLTF_Opened_Front_-_Compressed.glb"
            camera-controls
            shadow-intensity="1"
            >
            <button
                id="ext-hotspot-1"
                class="ext-hotspot-button"
                aria-label="hotspot 1"
                slot="hotspot-1"
                data-slide="1"
                data-position="-0.017m 2.565m 0.290m"
                data-normal="0.024 0.500 0.866">
                +
            </button>
            <button
                id="ext-hotspot-2"
                class="ext-hotspot-button"
                aria-label="hotspot 2"
                slot="hotspot-2"
                data-slide="2"
                data-position="0.772m 1.198m 0.810m"
                data-normal="-0.658 0.369 0.657">
                +
            </button>
            <button
                id="ext-hotspot-3"
                class="ext-hotspot-button"
                aria-label="hotspot 3"
                slot="hotspot-3"
                data-slide="3"
                data-position="-0.018m 0.624m 1.074m"
                data-normal="0.029 0.193 0.981">
                +
            </button>
            <button
                id="ext-hotspot-4"
                class="ext-hotspot-button"
                aria-label="hotspot 4"
                slot="hotspot-4"
                data-slide="4"
                data-position="-0.004m -0.510m 1.496m"
                data-normal="0.0004 0.84797 0.5302">
                +
            </button>
            <button
                id="ext-hotspot-5"
                class="ext-hotspot-button"
                aria-label="hotspot 5"
                slot="hotspot-5"
                data-slide="5"
                data-position="-0.834m 1.269m 0.191m"
                data-normal="-0.879 0.476 -0.035">
                +
            </button>            
        </model-viewer>
         <svg class="connections">
                <line id="hotspot-line"></line>
            </svg>
        </div>
        `;

        init();
        bindEvents();
        showClose();
    }

document.addEventListener("DOMContentLoaded", evt => {
    button3D.addEventListener('click', load3D);
});
})();

